import "typeface-nunito";

const fontSans =
  '"Nunito", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";';

export default {
  body: fontSans,
  heading: fontSans,
  monospace: "Menlo, monospace"
};
